import { render, staticRenderFns } from "./AddressFormModal.vue?vue&type=template&id=4993b77e&scoped=true&"
import script from "./AddressFormModal.vue?vue&type=script&lang=js&"
export * from "./AddressFormModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressFormModal.vue?vue&type=style&index=0&id=4993b77e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993b77e",
  null
  
)

export default component.exports